export const getStyleStringFromObject = (styleObject) => {
    return Object.keys(styleObject)
        .map((key) => {
            // Convert camelCase property names to kebab-case (CSS format)
            const cssProperty = key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

            // Get the value and append 'px' to numeric values that need it
            let value = styleObject[key];
            if (typeof value === 'number' && !isUnitlessNumber(key)) {
                value = `${value}px`;
            }

            return `${cssProperty}: ${value}`;
        })
        .join('; ');
};

// Helper function to determine which numbers don't need 'px'
const isUnitlessNumber = (property) => {
    // A non-exhaustive list of properties that are unitless
    const unitlessProps = ['animationIterationCount', 'boxFlex', 'boxFlexGroup', 'boxOrdinalGroup', 'columnCount', 'flex', 'flexGrow', 'flexPositive', 'flexShrink', 'flexNegative', 'flexOrder', 'fontWeight', 'lineHeight', 'matchPrecedence', 'opacity', 'order', 'orphans', 'tabSize', 'widows', 'zIndex', 'zoom', 'fillOpacity', 'stopOpacity', 'strokeDashoffset', 'strokeOpacity', 'strokeWidth'];
    return unitlessProps.includes(property);
};